var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoblieMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Moblie_Menu",
    "data-name": "Moblie Menu",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1085",
    "data-name": "Line 1085",
    x2: 24,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1086",
    "data-name": "Line 1086",
    x2: 24,
    transform: "translate(0 6)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1087",
    "data-name": "Line 1087",
    x2: 24,
    transform: "translate(0 12)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1103",
    "data-name": "Line 1103",
    x2: 24,
    transform: "translate(0 18)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoblieMenu);
export default __webpack_public_path__ + "static/media/Moblie Menu.4c536c58ce0ee6c0dfe1dfc814f3d3f7.svg";
export { ForwardRef as ReactComponent };